import { createApiCall } from 'lib/base';

interface EditStockProductBody {
  name: string;
  description: string;
  logo: string;
}

const EDIT_STOCK_PRODUCT = 'EDIT_STOCK_PRODUCT';

export const editStockProductBody = createApiCall<
  EditStockProductBody & { id: string; payload: any }
>(EDIT_STOCK_PRODUCT, ({ id, payload }) => ({
  endpoint: `api/admin/stocks/${id}`,
  method: 'PUT',
  body: payload,
}));

export default editStockProductBody;
